import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import LOCALES_PT from './pt/locales';
import LOCALES_ES from './es/locales';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: {
        translation: LOCALES_PT,
      },
      es: {
        translation: LOCALES_ES,
      },
    },
    supportedLngs: ['pt', 'es'],
    fallbackLng: 'pt',
  });

export default i18n;
